@if (isDisabled) {
<app-alert-card type="info" [icon]="'info'" [closable]="false">
    Como a opção "Selecionar todos os produtos automaticamente" está ligada, não é necessário escolher os
    itens manualmente. Os novos produtos cadastrados também entrarão nesta lista de forma automática.
</app-alert-card>
} @else {

<div class="d-flex justify-content-between align-items-center mb-3">
    <span class="small">{{ produtos.length }} produto(s) na lista</span>
    <button type="button" mat-button class="btn-add-right" (click)="adicionarLinha()">
        <mat-icon>add</mat-icon> Adicionar mais itens
    </button>
</div>

<!-- Linha de Adição -->
@if (showAddRow) {
<div class="add-row-container mb-3">
    <div class="row align-items-center">
        <div class="col-12 col-md-5">
            <app-select-pesquisavel [control]="novoProdutoControl" [apiUrl]="urlProduto" label="Produto"
                idField="idProduto" nameField="descricao" (selectionChange)="onNovoProdutoSelecionado($event)"
                [subscriptSizing]="'dynamic'">
            </app-select-pesquisavel>
        </div>
        @if (isMetodoManual) {
        <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Preço na Lista</mat-label>
                <input matInput type="text" [(ngModel)]="novoPrecoLista" placeholder="0,00"
                    [currencyMask]="currencyMask">
            </mat-form-field>
        </div>
        }
        <div class="col-12 col-md-auto d-flex gap-2">
            @if (isCalculando) {
            <mat-spinner [diameter]="30"></mat-spinner>
            } @else {
            <button type="button" mat-flat-button class="btn-primary" (click)="confirmarAdicao()">
                <mat-icon>check</mat-icon> Adicionar
            </button>
            <button type="button" mat-button (click)="cancelarAdicao()">
                <mat-icon>close</mat-icon> Cancelar
            </button>
            }
        </div>
    </div>
</div>
}

<!-- Filtro -->
@if (produtos.length > 0) {
<div class="row">
    <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100 mb-2" subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Filtrar produtos</mat-label>
            <input matInput [(ngModel)]="filtroTexto" (ngModelChange)="onFilter()"
                placeholder="Buscar por nome, código, preço...">
            @if (filtroTexto) {
            <button matSuffix mat-icon-button (click)="filtroTexto = ''; onFilter()">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
    </div>
</div>
}

<!-- Tabela de Produtos -->
@if (produtos.length > 0) {
<div class="table-responsive">
    <table mat-table [dataSource]="produtosVisiveis" matSort (matSortChange)="onSort($event)" class="w-100">

        <!-- Produto -->
        <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Produto</th>
            <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
        </ng-container>

        <!-- SKU -->
        <ng-container matColumnDef="codigoSku">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU</th>
            <td mat-cell *matCellDef="let element">{{ element.codigoSku || '-' }}</td>
        </ng-container>

        <!-- Preço Original -->
        <ng-container matColumnDef="precoOriginal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preço Original</th>
            <td mat-cell *matCellDef="let element">{{ element.precoOriginal | abnt:'preco' }}</td>
        </ng-container>

        <!-- Preço Lista -->
        <ng-container matColumnDef="precoLista">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Preço Lista</th>
            <td mat-cell *matCellDef="let element; let i = index">
                @if (editingIndex === i && isMetodoManual) {
                <mat-form-field appearance="outline" class="w-100 field-inline" subscriptSizing="dynamic">
                    <input matInput type="text" [(ngModel)]="editingPrecoLista" placeholder="0,00"
                        [currencyMask]="currencyMask">
                </mat-form-field>
                } @else {
                {{ element.precoLista != null ? (element.precoLista | abnt:'preco') : '-' }}
                }
            </td>
        </ng-container>

        <!-- Margem -->
        <ng-container matColumnDef="margem">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Margem
                <mat-icon class="help-icon-inline"
                    matTooltip="A margem é a diferença percentual entre o custo médio e o preço do produto nesta tabela">
                    help_outline
                </mat-icon>
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.margem != null ? (element.margem | number:'1.2-2') + '%' : '-' }}
            </td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let element; let i = index" class="text-center w-actions">
                <div class="d-flex justify-content-center">
                    @if (editingIndex === i) {
                    <button mat-icon-button color="primary" matTooltip="Salvar" (click)="confirmarEdicao()">
                        <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Cancelar" (click)="cancelarEdicao()">
                        <mat-icon>close</mat-icon>
                    </button>
                    } @else {
                    @if (isMetodoManual) {
                    <button mat-icon-button matTooltip="Editar preço" (click)="editarProduto(i)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    }
                    <button mat-icon-button type="button" matTooltip="Remover produto" (click)="removerProduto(i)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
@if (hasMore) {
<div class="text-center mt-3">
    <button type="button" mat-button class="btn-ver-mais" (click)="verMais()">
        <mat-icon>expand_more</mat-icon>
        Ver mais ({{ produtosVisiveis.length }} de {{ produtos.length }})
    </button>
</div>
}
} @else {
<div class="empty-contacts">
    Nenhum produto adicionado à lista.
</div>
}
}